import React, { SVGProps } from 'react'
export const FirstDefaultLeftSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="36"
    viewBox="0 0 16 36"
    fill="none"
    {...props}
  >
    <path
      fill="#7F7472"
      fillRule="evenodd"
      d="M6.274 6.063c-2.376 2.1-3.966 5.05-4.828 9.18-1.502 7.194.742 12.135 4.033 15.29 3.32 3.183 7.724 4.495 10.521 4.495V36c-3.042 0-7.688-1.406-11.192-4.765C1.276 27.85-1.074 22.569.497 15.043c.893-4.279 2.564-7.438 5.136-9.71C8.2 3.068 11.696 1.737 16 1v.982c-4.204.718-7.343 1.976-9.726 4.08Z"
      clipRule="evenodd"
    />
  </svg>
)
